import React from 'react';
import { Grid } from '@mui/material';
import PreviewCard from 'components/PreviewCard/PreviewCard';
import { Document, MenuOption } from 'dataTypes/document';
import { File } from 'dataTypes/file';
import { Template } from 'dataTypes/template';
import { DocumentType } from 'features/document/documentSlice';
import documentSvg from 'assets/images/NewFileOptionsIcons/document-option-icon.svg';
import contractSvg from 'assets/images/NewFileOptionsIcons/contract-option-icon.svg';
import quoteSvg from 'assets/images/NewFileOptionsIcons/quote-option-icon.svg';

interface ListCardPreviewProps {
  data: Document[] | Template[];
  menuItems?: (id: number, name: string, status: string, type: string, isDefault?: boolean) => MenuOption[];
  toggleFavorite?: (
    event: React.MouseEvent<HTMLButtonElement>,
    id: number,
    name: string,
    isDocFavorite: boolean
  ) => void;
  handleOpen?: (id: number, type: string, status: string) => void;
}

const getThumbnail = (docType: string, files?: File[] | File) => {
  const thumbnailUrl = Array.isArray(files) ? files?.find(obj => obj.isDocumentPreview)?.url : files?.url;

  if (thumbnailUrl) return thumbnailUrl;
  if (docType === DocumentType.CONTRACT) return contractSvg;
  if (docType === DocumentType.QUOTE) return quoteSvg;
  return documentSvg;
};

export const CardListPreview: React.FC<ListCardPreviewProps> = ({ data, menuItems, toggleFavorite, handleOpen }) => {
  return (
    <Grid container flexWrap='wrap' justifyContent='flex-start' gap={3}>
      {data.map(document => {
        const isDefault = 'isDefault' in document ? document.isDefault : false;
        return (
          <Grid key={`preview-card-${document.id}`} item>
            <PreviewCard
              key={document.id}
              id={document.id}
              label={document.name}
              createdAt={String(document.createdAt)}
              lastModified={String(document.updatedAt)}
              // TODO: Document and Templates should have the same property 'files' from the Backend
              preview={getThumbnail(document.type, 'files' in document ? document.files : document.file)}
              isFavorite={document.isFavorite}
              isDefault={isDefault}
              menuItems={menuItems!(document.id, document.name, document.status, document.type, isDefault)}
              onStarClick={e => toggleFavorite!(e, document.id, document.name, document.isFavorite)}
              onClick={() => handleOpen!(document.id, document.type, document.status)}
            />
          </Grid>
        );
      })}
    </Grid>
  );
};
